import {ActionType, createAction} from 'typesafe-actions';
import {Notification} from '../../interfaces/Notification';

export const notificationModuleSaveNewNotification = createAction(
    'NOTIFICATION_MODULE_SAVE_NEW_NOTIFICATION',
    (action) => (notification: Notification | null) => action({notification}),
);

export type ActionTypes = ActionType<typeof notificationModuleSaveNewNotification>;
